import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'pöytätilaus',
    [ORDER_METHODS.PICKUP]: 'nouto',
    [ORDER_METHODS.DELIVERY]: 'toimitus',
  },
  errors: {
    draft_validation_failed: 'Täytä toimitusosoite ennen jatkamista.',
  },
};
